import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RankmiTable } from '@rankmi/rankmi-table'
import { faBook } from '@fortawesome/pro-solid-svg-icons/faBook'
import { rolesService } from 'api/configuration/roles'
import { ICourse, ILearningProgram } from 'interfaces/roles'
import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'
import { RankmiTableWrapper } from './styled'

interface IProps {
  learningProgram: ILearningProgram
  close: () => void
}

const Detail = ({ learningProgram, close }: IProps) => {
  const { t } = useTranslation()
  const prefix =
    'configuration.rolesAndPermissions.form.sections.accessToLearningPrograms.learningPrograms.table.headers.courses.detail'
  const [loading, setLoading] = useState(false)
  const [courses, setCourses] = useState<ICourse[]>([])

  useEffect(() => {
    getCourses()
  }, [])

  const getCourses = async () => {
    setLoading(true)
    await rolesService
      .getCoursesByLearningProgram(learningProgram.id)
      .then((response) => {
        setCourses(response.data)
      })
    setLoading(false)
  }

  const locale = {
    header: {
      rowsCount: t(`${prefix}.table.rowsCount`),
      rowsCount_plural: t(`${prefix}.table.rowsCount_plural`),
    },
  }

  const columns = [
    {
      title: `${t(`${prefix}.table.headers.name`)}`,
      key: 'name',
      render: (name: string) => name,
    },
  ]

  return (
    <Modal
      isOpen={true}
      title={t(`${prefix}.table.title`)}
      maxwidth={480}
      maxheight={492}
      close={close}
      actions={
        <ModalButtons
          secondaryText={t(`${prefix}.table.actions.close`)}
          secondaryAction={close}
        />
      }
    >
      <RankmiTableWrapper>
        <RankmiTable
          columnHeaders={columns}
          data={courses}
          countIcon={faBook}
          total={courses.length}
          locale={locale}
          loading={loading}
        />
      </RankmiTableWrapper>
    </Modal>
  )
}

export default Detail
